<template>
  <div class="search-form" :class="{ 'is-open': isOpen }">
    <BaseInputSearch
      v-model="searchValue"
      :placeholder="$tc('lobby.search.input')"
      type="text"
      class="search-form__input"
      :error-messages="errorSearch"
      :is-focus="isFocus"
      @blur="validateText"
      @input="inputHandler"
      @click="$emit('open')"
      @keyup.enter="onKeyupEnter"
    />
    <slot name="trigger" />

    <UiBtn
      class="search-form__close"
      color="gray"
      icon="common/close"
      size-small-mobile
      @click="$emit('close')"
    />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { minLength, maxLength } from 'vuelidate/lib/validators'
import BaseInputSearch from '~/components/Base/Input/Search'

const MIN_LENGTH_INPUT = 3
const MAX_LENGTH_INPUT = 100

export default {
  name: 'SearchForm',
  components: { BaseInputSearch },
  mixins: [validationMixin],
  props: {
    isOpen: { type: Boolean },
  },
  data() {
    return {
      searchValue: '',
      errorSearch: [],
      isFocus: false,
    }
  },
  validations() {
    return {
      searchValue: {
        minLength: minLength(MIN_LENGTH_INPUT),
        maxLength: maxLength(MAX_LENGTH_INPUT),
      },
    }
  },
  watch: {
    isOpen(v) {
      if (v) {
        this.isFocus = true
      }
      else {
        this.isFocus = false
        this.searchValue = ''
        this.$emit('input', this.searchValue)
      }
    },
  },
  methods: {
    inputHandler() {
      this.errorSearch = []
      this.$emit('input', this.searchValue)
    },
    validateText() {
      this.$v.searchValue.$touch()
      this.errorSearch = []

      if (!this.$v.searchValue.minLength) {
        this.errorSearch.push(this.$tc('lobby.search.inputError'))
      }
      else if (!this.$v.searchValue.maxLength) {
        this.errorSearch.push(this.$tc('lobby.search.inputMaxError'))
      }
    },
    onKeyupEnter() {
      this.validateText()
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
